import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Typography from '@mui/material/Typography';
import MuiTooltip from '@mui/material/Tooltip';
import { getPlacement } from '../utils/navigation-utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var offsetValues = {
  'bottom-end': -12,
  'bottom-start': 12,
  'top-end': -12,
  'top-start': 12
};
export function Tooltip(props) {
  var _offsetValues$placeme;
  var children = props.children,
    description = props.description,
    label = props.label,
    maxWidth = props.maxWidth,
    open = props.open,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'None' : _props$placement,
    slotProps = props.slotProps,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'light' : _props$variant,
    width = props.width;
  var placementValue = getPlacement(placement);
  return /*#__PURE__*/_jsx(MuiTooltip, {
    PopperProps: {
      sx: {
        zIndex: 2005 // must be higher than Popover component
      }
    },
    arrow: placement !== 'None',
    componentsProps: {
      tooltip: {
        sx: {
          '.MuiTypography-root:first-child': {
            marginBottom: description ? '4px' : '0px'
          },
          maxWidth: width ? 'none' : maxWidth,
          padding: description ? '12px !important' : '8px 12px !important',
          width: width
        }
      }
    },
    open: open,
    placement: placementValue,
    slotProps: _extends({
      popper: {
        modifiers: [{
          name: 'offset',
          options: {
            offset: [placementValue ? (_offsetValues$placeme = offsetValues[placementValue]) != null ? _offsetValues$placeme : 0 : 0, 0]
          }
        }]
      }
    }, slotProps),
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Typography, {
        color: "inherit",
        variant: "text-xs-bold",
        children: label
      }), /*#__PURE__*/_jsx(Typography, {
        color: "inherit",
        variant: "text-xs-light",
        children: description
      })]
    }),
    variant: variant,
    "data-element": "MuiTooltip",
    "data-component": "Tooltip",
    "data-source-file": "Tooltip.tsx",
    children: children
  });
}